import styled from "styled-components";

export const CardImgTitle = styled.div`
	padding: 4.75rem;
	background-color: rgb(0, 27, 72);
	color: #fff;
	display: flex;
	align-items: center;

	& h5 {
		margin-left: 1.25rem;
		font-size: 1rem;
		font-weight: 700;
		text-transform: uppercase;
	}

	@media(max-width:1250px){
		padding: 3.75rem;
	}

@media(max-width:1150px){
		padding: 2.75rem;
	}
@media(max-width:998px){
	width:100% !important;
}

@media(max-width:390px){
	padding: 1.25rem;
	& h5 {
		font-size: 0.8rem;
	}
}
`